export * from './auth.guard';
import { AuthGuard } from './auth.guard';
export * from './no-auth.guard';
import { NoAuthGuard } from './no-auth.guard';

export const GUARDS = [
  AuthGuard,
  NoAuthGuard
];
